module.exports = __webpack_public_path__ + "com_index_8bg.png?d84a4f9bd22cdcc29317c7d74378e95f";


//////////////////
// WEBPACK FOOTER
// ./static/images/com_index_8bg.png
// module id = 315
// module chunks = 0